import { compose } from 'recompose';
import FiltersRow from './filtersRow';

const enhance = compose();
export default enhance(FiltersRow);
